export const TEAM_PANEL = 'TEAM'
export const RECORD_PANEL = 'RECORD'

export type PanelTypes = typeof TEAM_PANEL | typeof RECORD_PANEL